export function separate(value: any) {
  let numberedValue = Number(value).toString();

  if (value) {
    numberedValue += "";
    numberedValue = numberedValue.replace(",", "");
    const x = numberedValue.split(".");
    let y = x[0];
    const z = x.length > 1 ? "." + x[1] : "";
    const rgx = /(\d+)(\d{3})/;
    while (rgx.test(y)) y = y.replace(rgx, "$1" + "," + "$2");
    return y + z;
  } else {
    return 0;
  }
}